import '../scss/main.scss';
import { registerQBlock, registerQBlockResults } from './qblock';
import ifEmoji from 'if-emoji';

registerClearSession(document);
registerQBlock(document);
registerQBlockResults(document);
registerLinkCards(document);
registerEmojiGlobal(document);
register_burger_menu(document);

function registerClearSession($root = document) {
    const $el = document.querySelector('.clear-session');
    if (!$el) {
        return;
    }
    const $session_id = $el.querySelector('.session-id');
    const $email_sent = $el.querySelector('.email-sent');
    const db_json = window.localStorage.getItem('qblocks_db');
    const db = db_json ? JSON.parse(db_json) : null;
    if (db) {
        $session_id.textContent = db.user;
        const email_sent_list = Object.entries(db.qblocks).filter(([k, v]) => v.email_sent).map(([k, v]) => k).join(', ');
        $email_sent.textContent = email_sent_list || 'false';
    }
    const $button = $el.querySelector('button');
    $button.addEventListener('click', event => {
        event.preventDefault();
        window.localStorage.removeItem('qblocks_db');
        window.localStorage.removeItem('email_sent');
        $session_id.textContent = 'none';
        $email_sent.textContent = 'false';
        window.location.reload();
    });
}

function registerLinkCards($root = document) {
    const $link_cards = document.querySelectorAll('.link-card');
    const $finished = document.querySelector('.list-finished');
    const db_json = window.localStorage.getItem('qblocks_db');
    $link_cards.forEach($link_card => {
        $link_card.addEventListener('click', event => {
            $link_card.querySelector('a').click();
        })
    })
    if (!db_json) {
        return;
    }
    const db = JSON.parse(db_json);
    let has_finished = false;
    $link_cards.forEach($link_card => {
        const id = parseInt($link_card.dataset.id);
        const qblock = db.qblocks[id];
        if (qblock && !qblock.questions.find(question => !question.answer)) {
            $link_card.classList.add('finished');
            if ($link_card.classList.contains('link-card-finished')) {
                has_finished = true;
            }
        }
    });
    if (has_finished) {
        $finished.classList.remove('none');
    }
}

function registerEmojiGlobal($root = document) {
    const $emojis = $root.querySelectorAll('.conditional-emoji');
    $emojis.forEach($el => {
        if (!ifEmoji($el.textContent)) {
            $el.classList.add('use-noto-emoji-global');
        } else {
            $el.classList.remove('use-noto-emoji-global');
        }
    });
}

function register_burger_menu($root = document) {
    const $body = document.querySelector('body');
    const $header = document.querySelector('.header');
    const $open = $header.querySelector('.dispatch--menu-open');
    const $close = $header.querySelector('.dispatch--menu-close');
    $open.addEventListener('click', event => {
        event.preventDefault();
        $body.classList.remove('state--menu-closed');
        $body.classList.add('state--menu-opened');
    });
    $close.addEventListener('click', event => {
        event.preventDefault();
        $body.classList.remove('state--menu-opened');
        $body.classList.add('state--menu-closed');
    });
}